import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';

const BEM_BLOCK: string = 'sc-home-type-card';

@Component({
    selector: 'sc-home-type-card',
    templateUrl: './home-type-card.component.html',
    styleUrl: './home-type-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,

        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class HomeTypeCardComponent {
    public readonly link: InputSignal<string> = input.required<string>();
    public readonly num: InputSignal<string> = input.required<string>();
    public readonly specs: InputSignal<string> = input.required<string>();
    public readonly proj: InputSignal<string> = input.required<string>();
    public readonly axis: InputSignal<string> = input.required<string>();
    public readonly caption: InputSignal<string> = input.required<string>();
    public readonly desc: InputSignal<string> = input.required<string>();
}
